<template>
    <div class="outer">

        <div class="type-nav">
            <div class="container">
                <h2 class="all">
                    <i class="iconfont icon-fenlei"></i><span class="py10">Category</span><i
                        class="iconfont icon-xiangxia"></i>
                </h2>
                <nav class="nav">
                    <a @click="$router.push('/newArrival')" class="font-16 hoverRed pointer">What's New</a>
                    <a @click="$router.push('/flashSale')" class="font-16 hoverRed pointer">Flash Sale</a>
                </nav>
                <div class="sort">
                    <div class="all-sort-list2">
                        <div class="item bo">
                            <h3 class="hoverRedBold pointer" @click="gotoType('Shoes')">
                                <img src="../../assets/images/cat/shoes.png" alt="">
                                <a>Shoes</a>
                            </h3>
                            <div class="item-list clearfix" @click="gotoType('Shoes')">
                                <div class="subitem">
                                    <dl class="fore">
                                        <dt>
                                            <a>Men's Shoes</a>
                                        </dt>
                                        <dd>
                                            <em>
                                                <a>Boots</a>
                                            </em>
                                            <em>
                                                <a>Flats</a>
                                            </em>
                                            <em>
                                                <a>Sneakers</a>
                                            </em>
                                            <em>
                                                <a>Athletic</a>
                                            </em>
                                            <em>
                                                <a>Sandals</a>
                                            </em>
                                        </dd>
                                    </dl>
                                    <dl class="fore">
                                        <dt>
                                            <a>Women's Shoes</a>
                                        </dt>
                                        <dd>
                                            <em>
                                                <a>Athletic</a>
                                            </em>
                                            <em>
                                                <a>Heels</a>
                                            </em>
                                            <em>
                                                <a>Boots</a>
                                            </em>
                                            <em>
                                                <a>Flats</a>
                                            </em>
                                            <em>
                                                <a>Sneakers</a>
                                            </em>
                                        </dd>
                                    </dl>
                                    <dl class="fore">
                                        <dt>
                                            <a>Kids&Baby shoes</a>
                                        </dt>
                                        <dd>
                                            <em>
                                                <a>Kids Sneaker</a>
                                            </em>
                                            <em>
                                                <a>School Shoes</a>
                                            </em>
                                            <em>
                                                <a>Kids Boots</a>
                                            </em>
                                            <em>
                                                <a>Kids Loafer</a>
                                            </em>
                                            <em>
                                                <a>Kids Athletic</a>
                                            </em>
                                        </dd>
                                    </dl>
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <h3 class="hoverRedBold pointer" @click="gotoType('Bags')">
                                <img src="../../assets/images/cat/bags.png" alt="">
                                <a>Bags</a>
                            </h3>
                            <div class="item-list clearfix" @click="gotoType('Bags')">
                                <div class="subitem">
                                    <dl class="fore">
                                        <dt>
                                            <a>Women's Bags</a>
                                        </dt>
                                        <dd>
                                            <em>
                                                <a>Top-Handle Bags</a>
                                            </em>
                                            <em>
                                                <a>Crossbody Bags</a>
                                            </em>
                                            <em>
                                                <a>Tote Bags</a>
                                            </em>
                                            <em>
                                                <a>Shoulder Bags</a>
                                            </em>
                                            <em>
                                                <a>Fashion Backpacks</a>
                                            </em>
                                        </dd>
                                    </dl>
                                    <dl class="fore">
                                        <dt>
                                            <a>Men's Bags</a>
                                        </dt>
                                        <dd>
                                            <em>
                                                <a>Fashion Backpacks</a>
                                            </em>
                                            <em>
                                                <a>Wallets & Holders</a>
                                            </em>
                                            <em>
                                                <a>Cross-BodySling Bags</a>
                                            </em>
                                            <em>
                                                <a>Shoulder Bags</a>
                                            </em>
                                            <em>
                                                <a>Waist Packs</a>
                                            </em>
                                        </dd>
                                    </dl>
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <h3 class="hoverRedBold pointer" @click="gotoType('Appliances')">
                                <img src="../../assets/images/cat/appliances.png" alt="">
                                <a>Appliances</a>
                            </h3>
                            <div class="item-list clearfix" @click="gotoType('Appliances')">
                                <div class="subitem">
                                    <dl class="fore">
                                        <dt>
                                            <a>Home lmprovement</a>
                                        </dt>
                                        <dd>
                                            <em>
                                                <a>Refrigerators</a>
                                            </em>
                                            <em>
                                                <a>Standing Gas Cookers</a>
                                            </em>
                                            <em>
                                                <a>Freezer</a>
                                            </em>
                                            <em>
                                                <a>Washers & Dryers</a>
                                            </em>
                                            <em>
                                                <a>Vacuums</a>
                                            </em>
                                        </dd>
                                    </dl>
                                    <dl class="fore">
                                        <dt>
                                            <a>Small Appliance</a>
                                        </dt>
                                        <dd>
                                            <em>
                                                <a>Electric Kettles</a>
                                            </em>
                                            <em>
                                                <a>Cooktops</a>
                                            </em>
                                            <em>
                                                <a>Blenders & Juicers</a>
                                            </em>
                                            <em>
                                                <a>Water Dispensers</a>
                                            </em>
                                            <em>
                                                <a>Ovens</a>
                                            </em>
                                        </dd>
                                    </dl>
                                    <dl class="fore">
                                        <dt>
                                            <a>Specialty Appliance</a>
                                        </dt>
                                        <dd>
                                            <em>
                                                <a>Egg Cookers</a>
                                            </em>
                                            <em>
                                                <a>Chapati</a>
                                            </em>
                                            <em>
                                                <a>Popcorn</a>
                                            </em>
                                            <em>
                                                <a>Coffee</a>
                                            </em>
                                            <em>
                                                <a>Sandwich</a>
                                            </em>
                                        </dd>
                                    </dl>
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <h3 class="hoverRedBold pointer" @click="gotoType('phones')">
                                <img src="../../assets/images/cat/phone.png" alt="">
                                <a>Phones & Accessories</a>
                            </h3>
                            <div class="item-list clearfix" @click="gotoType('phones')">
                                <div class="subitem">
                                    <dl class="fore">
                                        <dt>
                                            <a>Top Brands</a>
                                        </dt>
                                        <dd>
                                            <em>
                                                <a>Samsung</a>
                                            </em>
                                            <em>
                                                <a>Tecno</a>
                                            </em>
                                            <em>
                                                <a>OPPO</a>
                                            </em>
                                            <em>
                                                <a>Infinix</a>
                                            </em>
                                            <em>
                                                <a>Xiaomi</a>
                                            </em>
                                        </dd>
                                    </dl>
                                    <dl class="fore">
                                        <dt>
                                            <a>Mobile Phones</a>
                                        </dt>
                                        <dd>
                                            <em>
                                                <a>Smart Phones</a>
                                            </em>
                                            <em>
                                                <a>Refurbished Phones</a>
                                            </em>
                                            <em>
                                                <a>Featured Phones</a>
                                            </em>
                                        </dd>
                                    </dl>
                                    <dl class="fore">
                                        <dt>
                                            <a>Consumer Electronics</a>
                                        </dt>
                                        <dd>
                                            <em>
                                                <a>Wired Earphones</a>
                                            </em>
                                            <em>
                                                <a>Sports Earphones</a>
                                            </em>
                                            <em>
                                                <a>Bluetooth Earpods</a>
                                            </em>
                                        </dd>
                                    </dl>
                                    <dl class="fore">
                                        <dt>
                                            <a>Accessories</a>
                                        </dt>
                                        <dd>
                                            <em>
                                                <a>Mounts & Stands</a>
                                            </em>
                                            <em>
                                                <a>Gimbal Stabilizer</a>
                                            </em>
                                        </dd>
                                    </dl>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="list-outer">
            <img src="../../assets/images/home/background.jpg" alt="">
        </div>
        <div class="list-container">
            <div class="sortList clearfix">
                <div class="center">
                    <!--banner轮播-->
                    <div class="swiper-container" id="mySwiper">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide">
                                <img style="height:471px;width:100%;" src="../../assets/images/home/banner1.jpg" />
                            </div>
                            <div class="swiper-slide">
                                <img style="height:471px;width:100%;" src="../../assets/images/home/banner2.jpg" />
                            </div>
                            <!-- <div class="swiper-slide">
                                <img style="height:471px;width:100%;" src="../../assets/images/home/banner3.jpg" />
                            </div>
                            <div class="swiper-slide">
                                <img style="height:471px;width:100%;" src="../../assets/images/home/banner4.jpg" />
                            </div> -->
                        </div>
                        <!-- 如果需要分页器 -->
                        <div class="swiper-pagination"></div>

                        <!-- 如果需要导航按钮 -->
                        <div class="swiper-button-prev"></div>
                        <div class="swiper-button-next"></div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="today-recommend">
            <div class="py-container">
                <ul class="recommend">
                    <li @click="gotoType('Bags')" class="banner">
                        <img src="../../assets/images/home/cat3.jpg" />
                    </li>
                    <li @click="gotoType('phones')" class="banner">
                        <img src="../../assets/images/home/cat4.jpg" />
                    </li>
                    <li @click="gotoType('phones')" class="banner">
                        <img src="../../assets/images/home/cat2.jpg" />
                    </li>
                    <li @click="gotoType('Shoes')" class="banner">
                        <img src="../../assets/images/home/cat1.jpg" />
                    </li>
                </ul>
            </div>
        </div> -->

        <div class="rank">
            <div class="flex items-center borderbottom">
                <img src="../../assets/images/home/FlashSale.png" alt="">
                <div class="flashSale">Flash Sale</div>
            </div>
            <div class="content">
                <ul>
                    <li>
                        <div v-for="item in newFlashSaleList" @click="gotoProduct(item)" class="img-item">
                            <div class="tab-pic shadow">
                                <a>
                                    <img :src="item.homeImg" />
                                </a>
                                <div class="info-title ellipsis">
                                    <a>{{ item.obj1.name }}</a>
                                </div>
                                <div class="info-price">$ {{ item.obj1.money }}</div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <div class="rank ">
            <div class="flex items-center borderbottom">
                <div class="flashSale">Hot Category</div>
            </div>
            <div class="content" style="padding: 0;">
                <ul>
                    <li>
                        <div v-for="item in catList" @click="gotoType(item.type)" class="img-item">
                            <div style="padding:20px 15px 8px;" class="tab-pic shadow">
                                <a>
                                    <img style="width: 95px;height: 95px;" :src="item.homeImg" />
                                </a>
                                <div>
                                    <a>{{ item.type }}</a>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <div class="rank">
            <div class="flex items-center">
                <div class="flashSale">What's New</div>
            </div>
            <div class="content">
                <ul>
                    <li>
                        <div v-for="item in newNewList" @click="gotoProduct(item)" class="img-item" style="padding:5px">
                            <div class="tab-pic shadow" style="padding:8px">
                                <a>
                                    <img style="width:160px;height:170px;" :src="item.homeImg" />
                                </a>
                                <div class="info-price text-center">$ {{ item.obj1.money }}</div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <div class="rank">
            <div class="flex items-center">
                <img src="../../assets/images/home/icon_like.png" alt="">
                <div class="flashSale">You May Also Like</div>
            </div>
            <div class="content">
                <ul>
                    <li style="flex-wrap: wrap">
                        <div v-for="item in newHomeList" @click="gotoProduct(item)" class="img-item"
                            style="padding:10px 5px">
                            <div class="tab-pic shadow" style="padding:0px 8px 0 0">
                                <a>
                                    <img style="width:170px;height:170px;" :src="item.homeImg" />
                                </a>
                                <div style="width:170px" class="info-title ellipsis">
                                    <a>{{ item.obj1.name }}</a>
                                </div>
                                <div style="width:170px;padding-bottom: 8px;" class="info-price text-center">$ {{
                                    item.obj1.money }}</div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <div>
            <ul class="iconList">
                <li>
                    <img src="https://img.kilimall.com/c/h5/imgs/great-value@2x.png?x-image-process=image/format,webp/resize,w_200"
                        alt="">
                    <div class="bold-3">Great Value</div>
                </li>
                <li>
                    <img src="https://img.kilimall.com/c/h5/imgs/world-wide-delivery@2x.png?x-image-process=image/format,webp/resize,w_200"
                        alt="">
                    <div class="bold-3">Worldwide Delivery</div>
                </li>
                <li>
                    <img src="https://img.kilimall.com/c/h5/imgs/safe-payment@2x.png?x-image-process=image/format,webp/resize,w_200"
                        alt="">
                    <div class="bold-3">Safe Payment</div>
                </li>
                <li>
                    <img src="https://img.kilimall.com/c/h5/imgs/shop-with-confidence@2x.png?x-image-process=image/format,webp/resize,w_200"
                        alt="">
                    <div class="bold-3">Shop with Confidence</div>
                </li>
                <li>
                    <img src="https://img.kilimall.com/c/h5/imgs/help-center@2x.png?x-image-process=image/format,webp/resize,w_200"
                        alt="">
                    <div class="bold-3">24/7 Help Center</div>
                </li>
                <li>
                    <img src="https://img.kilimall.com/c/h5/imgs/shop-on-the-go@2x.png?x-image-process=image/format,webp/resize,w_200"
                        alt="">
                    <div class="bold-3">Shop On-The-Go</div>
                </li>
            </ul>
        </div>

        <div style="margin: 40px 0;">
            <div style="width: 1200px;margin: 0 auto;">
                <h2 style="margin-bottom: 18px;">QIANYUANMAIL</h2>
                <!-- <div style="margin-bottom: 15px;">QIANYUANMAIL is Kenya's leading online shopping mall. It was launched in
                    June 2014 with the mission of "Enriching Lives for Africa".</div> -->
                <div style="margin-bottom: 15px;">The number of individual consumers at QIANYUANMALL is growing
                    exponentially on a sustained basis. The platform boasts a comprehensive range of products. The mall
                    keeps expanding its business footprint, continuously diversifying its product categories,
                    streamlining the shopping process and improving shopping convenience for consumers.</div>
                <div>The range of services are designed to ensure optimum levels of convenience and customer
                    satisfaction with the retail process; order delivery-tracking, dedicated customer service support
                    and many other premium services. The company is highly customer-centric and are committed towards
                    finding innovative ways of improving the customers' shopping experience.</div>
            </div>
        </div>


        <!-- 底部 -->

    </div>
</template>
<script>
import Swiper from "swiper";
import "swiper/css/swiper.css";
// import '../../style/home.css';
import { homeList } from '@/json/home.js';
import { flashSaleList, newList } from '@/json/new.js';
export default {
    name: 'home',
    data() {
        return {
            newFlashSaleList: [],
            newNewList: [],
            catList: [],
            newHomeList: []
        };
    },
    components: {},
    methods: {
        gotoType(val) {
            this.$router.push({
                path: '/cats',
                query: {
                    type: val
                }
            })
        },
        gotoProduct(val) {
            this.$router.push({
                path: '/product',
                query: {
                    row: val
                }
            })
        },
    },
    mounted() {
        new Swiper(".swiper-container", {
            slidesPerView: 1,
            autoplay: {
                delay: 2000,
                disableOnInteraction: false,
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        })
        this.newHomeList = homeList.map(item => {
            return {
                ...item,
                obj1: {
                    ...item.obj1,
                    money: Number((item.obj1.money / 3000).toFixed(2))
                }
            }
        })
        this.catList = this.newHomeList.slice(16, 25)
        this.newFlashSaleList = flashSaleList.map(item => {
            return {
                ...item,
                obj1: {
                    ...item.obj1,
                    money: Number((item.obj1.money / 3000).toFixed(2))
                }
            }
        }).slice(0, 5)
        this.newNewList = newList.map(item => {
            return {
                ...item,
                obj1: {
                    ...item.obj1,
                    money: Number((item.obj1.money / 3000).toFixed(2))
                }
            }
        }).slice(0, 6)

    }
}
</script>
<style lang="less" scoped>
.swiper-container {
    --swiper-navigation-color: #98939b;
    /* 单独设置按钮颜色 */
    --swiper-navigation-size: 30px;
    /* 设置按钮大小 */
}

.list-outer {
    position: absolute;

    img {
        width: 100%;
    }
}
</style>